import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { BASKET_DEAL_PRODUCT_DATES } from '../../brands/default/content/components/checkout';
import ThemeContext from '../../providers/ThemeProvider';

export default function BasketDealProductDates({
  product,
  className,
  isChannelManagerDeal,
}) {
  const theme = useContext(ThemeContext);

  return (
    <>
      <p className={classNames('dates', className)}>
        {/* SAME DATE */}
        {product.checkInDate &&
          product.checkInDate === product.checkOutDate && (
            <span className="dates__date">
              <strong>{BASKET_DEAL_PRODUCT_DATES.date}:</strong>{' '}
              {product.checkInDate}
            </span>
          )}
        {/* DIFFERENT DATES */}
        {product.checkInDate &&
          product.checkInDate !== product.checkOutDate && (
            <>
              <span className="dates__date">
                <strong>{BASKET_DEAL_PRODUCT_DATES.checkIn}:</strong>{' '}
                {product.checkInDate}
              </span>
              <span className="dates__date">
                <strong>{BASKET_DEAL_PRODUCT_DATES.checkOut}:</strong>{' '}
                {product.checkOutDate}
              </span>
            </>
          )}
        {isChannelManagerDeal && product.numberOfNights && (
          <span className="dates__date">
            <strong>{BASKET_DEAL_PRODUCT_DATES.nights}:</strong>{' '}
            {product.numberOfNights}
          </span>
        )}
      </p>

      <style jsx>{`
        .dates {
          color: ${theme.colors.primary};
          text-transform: ${theme.text.transform};
        }
        .dates__date {
          margin-right: 14px;
        }
        .dates {
          display: none;
        }
        .dates--mobile {
          display: block;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .dates {
            display: block;
          }
          .dates--mobile {
            display: none;
          }
        }
      `}</style>
    </>
  );
}

BasketDealProductDates.propTypes = {
  className: PropTypes.string,
  isChannelManagerDeal: PropTypes.bool,
  product: PropTypes.object,
};
